import { ApiBase } from "./ApiBase";

export interface IUploadTask {
	taskId: string;
	method: "put";
	bodyType: "file";
	url: string;
}

export interface IImportJob {
	id: string;
	sources: IImportJobSource[];
	targetType: string;
	fieldValidations: IImportFieldValidation[];
	targetFields: { [key: string]: IImportTargetField };
}

export interface IImportFieldValidation {
	type: "required";
	count: number;
	fields: string[];
}

export interface IImportTargetField {
	name: string;
	displayName: string;
	order: number;
	options: IImportTargetFieldOptions[];
}

export interface IImportTargetFieldOptions {
	name: string;
	displayName: string;
	type: string;
	default: any;
}

export interface IImportJobSource {
	id: string;
	name: string;
	columnCount: number;
	rowCount: number;
	chunks: IImportChunk[];
}

export interface IImportChunk {
	id: string;
	offset: number;
	count: number;
	url: string;
}

export interface IImportChunkData {
	jobId: string;
	sourceId: string;
	chunkId: string;
	offset: number;
	count: number;
	rows: IImportChunkDataRow[];
}

export interface IImportChunkDataRow {
	id: string;
	values: string[];
}

export class SystemImportApi extends ApiBase {
	public uploadTempFile(): Promise<IUploadTask> {
		return this.client.callCfc("SystemImport.uploadTempFile", {});
	}

	public newJobFromUpload(uploadTaskId: string, targetType: string): Promise<IImportJob> {
		return this.client.callCfc("SystemImport.newJobFromUpload", { uploadTaskId, targetType });
	}

	public previewMappingForValues(targetType: string, targetField: string, mapping: any, rows: IImportChunkDataRow[]): Promise<IImportJob> {
		return this.client.callCfc("SystemImport.previewMappingForValues", { targetType, targetField, mapping, rows });
	}

	public runImport(jobId: string, sourceId: string, mapping: any): Promise<void> {
		return this.client.callCfc("SystemImport.runImport", { jobId, sourceId, mapping });
	}

	public exportFailedRows(jobId: string, sourceId: string): Promise<any> {
		return this.client.callCfc("SystemImport.exportFailedRows", { jobId, sourceId });
	}
}



// WEBPACK FOOTER //
// ./src/lib/api/SystemImportApi.ts